const businessLocation = { lat: 50.9530053, lng: 6.8960727 }
const mapStyles = [ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "poi", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "visibility": "on" }, { "color": "#5febaa" } ] } ]
import scrollMonitor from 'scrollmonitor'

class Maps {

  constructor () {
    this._element = document.querySelector('.js-map')
    this._map = null

    if (!this._element) {
      return
    }

    window.initMap = this.initMap.bind(this)
  }

  initMap () {

    this._map = new google.maps.Map(this._element, {
      zoom: 13,
      center: businessLocation,
      styles: mapStyles,
      clickableIcons: false,
      mapTypeControl: false,
      streetViewControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER
      },
    })

    let watcher = scrollMonitor.create(this._element, -300)
    watcher.enterViewport(() => {
      setTimeout(() => {this.addMarker()}, 1500)
      watcher.destroy()
    })
  }


  addMarker () {
    let markerIcon = new google.maps.MarkerImage(
      '/images/ui/map-marker.png',
      null, /* size is determined at runtime */
      null, /* origin is 0,0 */
      null, /* anchor is bottom center of the scaled image */
      (this._element.offsetWidth < 760) ? new google.maps.Size(44, 70) : new google.maps.Size(70,100)
    )

    let marker = new google.maps.Marker({
      map: this._map,
      position: businessLocation,
      animation: google.maps.Animation.DROP,
      icon: markerIcon
    });
  }
}

export default new Maps()
